import { render, staticRenderFns } from "./ResursForma.vue?vue&type=template&id=6564a0de&"
import script from "./ResursForma.vue?vue&type=script&lang=js&"
export * from "./ResursForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports